module.exports = require("vue-quill-editor");